const { gql } = require('@apollo/client');

export const QUERY_ARTICLES = gql`
  query QUERY_ARTICLES($status: ArticleStatus) {
    articles(status: $status) {
      booking {
        id
        status
        title
        type
      }
      payment {
        id
        status
        title
        type
      }
      property {
        id
        status
        title
        type
      }
    }
  }
`;
export const QUERY_GET_ARTICLE_DETAILS = gql`
  query QUERY_GET_ARTICLE_DETAILS($id: ID!) {
    article(id: $id) {
      article {
        articleData {
          content
          index
          type
          title
          links {
            hls
            hqMp4
            lqMp4
            thumbnail
          }
        }
        id
        image
        status
        textarea
        title
        type
        updatedAt
      }
    }
  }
`;
